function detectDeviceType() {
    const userAgent = navigator.userAgent;

    // 常见的移动设备关键词
    const mobileKeywords = [
        "Android",
        "iPhone",
        "iPad",
        "iPod",
        "Windows Phone",
        "BlackBerry",
        "Mobile",
        "Mobi",
    ];

    return mobileKeywords.some((keyword) => userAgent.includes(keyword))
        ? "mobile"
        : "desktop";
}

function setLocalStorage(key, value, ttl = 300000) {
    const now = new Date().getTime();
    const expiryTime = now + ttl;
    const item = {
        value: value,
        expiryTime: expiryTime,
    };
    localStorage.setItem(key, JSON.stringify(item));
}

function getLocalStorage(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
        return null;
    }
    const item = JSON.parse(itemStr);

    const now = new Date().getTime();
    if (now > item.expiryTime) {
        localStorage.removeItem(key);
        return null;
    }

    return item.value;
}

/**
 * 设置用户鉴权token
 * @param {String} token jwt token
 **/
function setToken(token) {
    return setCookie('token', token);
}

/**
 * 获取token
 **/
function getToken() {
    return getCookie("token");
}

//设置cookie
function setCookie(name, value, time = 30) {
    if (!name || value === undefined || value === null) return;
    var Days = time;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + encodeURIComponent(value) + ";expires=" + exp.toUTCString() + ";path=/";
}

function setAuthCookies(data = {}) {
    const userInfo = data.user_info || {};
    setCookie("juima_access_token", data.access_token);
    setCookie("juima_refresh_token", data.refresh_token);
    setCookie("juima_username", userInfo.username || data.username);
}
//官网登录cookie
function setWebCookie(name, value, time) {
    if (!name || !value) return;
    var exp = new Date();
    exp.setTime(time * 1000); // 将秒转换为毫秒
    document.cookie = name + "=" + encodeURIComponent(value) + ";expires=" + exp.toUTCString();
}

//获取cookie
function getCookie(name) {
    var arr = document.cookie.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
    if (arr != null) return decodeURIComponent(arr[2]);
    return null;
}

//删除cookie
function delCookie(name) {
    if (!name) return;
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    document.cookie = name + "=;expires=" + exp.toUTCString() + ";path=/";
}

function clearAuthCookies() {
    ["juima_access_token", "juima_refresh_token", "juima_username"].forEach(delCookie);
}

function toChineseNumber(num) {
    const chineseNumberMap = {
        '0': '零',
        '1': '一',
        '2': '两',
        '3': '三',
        '4': '四',
        '5': '五',
        '6': '六',
        '7': '七',
        '8': '八',
        '9': '九'
    };
    return num.toString().split('').map(ch => chineseNumberMap[ch]).join('');
}


function formatFileSize(bytes) {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
}

function getQueryParam(url, key) {
    const queryStringIndex = url.indexOf("?");
    let queryParams;
    if (queryStringIndex !== -1) {
        // 如果有查询字符串，则从URL中截取查询字符串并解析为对象
        const queryString = url.substring(queryStringIndex + 1);
        queryParams = new URLSearchParams(queryString);
    } else {
        // 如果没有查询字符串，则返回一个空对象
        queryParams = new URLSearchParams();
    }

    // 返回指定的查询参数值
    return queryParams.get(key);
}

function copyUrl(data) {
    // let sign = '';
    // if (data.sign) {
    //     sign = encodeURIComponent(data.sign);
    // }
    // let routePath = process.env.VUE_APP_BASE_API + "/#" + data.route + '?websocket_url=' + data.websocket_url + '&room_id=' + data.id + '&user_id=' + data.user_id + '&timestamp=' + data.timestamp + '&sign=' + sign;
    let routePath = data;
    if (process.env.NODE_ENV == 'development') {
        let newUrl = data.replace(/https?:\/\/[^/]+\/?/, '');
        routePath = window.origin + '/' + newUrl;
    }
    // let path = encodeURIComponent(routePath)
    // console.log(routePath,path)
    return routePath
}

async function checkMediaType(url) {
    const audioExtensions = ['mp3', 'wav', 'aac', 'ogg', 'flac'];
    const videoExtensions = ['mp4', 'avi', 'mov', 'mkv', 'flv', 'webm'];
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

    const extension = url.split('.').pop().toLowerCase(); // 获取文件扩展名

    if (audioExtensions.includes(extension)) {
        return 'Audio';
    } else if (videoExtensions.includes(extension)) {
        return 'Video';
    } else if (imageExtensions.includes(extension)) {
        return 'Image';
    } else {
        return 'Unknown';
    }
    // try {
    //     const response = await fetch(url, { method: 'HEAD' });
    //     const contentType = response.headers.get('content-type');

    //     if (contentType.startsWith('image/')) {
    //         return 'Image';
    //     } else if (contentType.startsWith('video/')) {
    //         return 'Video';
    //     } else if (contentType.startsWith('audio/')) {
    //         return 'Audio';
    //     } else {
    //         return 'Unknown';
    //     }
    // } catch (error) {
    //     console.error('Error fetching media type:', error);
    //     return 'Unknown';
    // }
}


function getSpecificParentClassName(targetElement) {
    let currentElement = targetElement;
    let nextCurrent = currentElement;
    while (currentElement && currentElement.tagName !== "HTML") {
        const currentClassName = currentElement.className;
        if (
            currentClassName.includes("container-main") ||
            currentClassName.includes("page-content")
        ) {
            return nextCurrent;
        } else {
            nextCurrent = currentElement;
        }
        currentElement = currentElement.parentNode;
    }
    return null;
}
// 直播装饰
function tagChangeView(ele) {
    if (!ele) return
    let data = JSON.parse(ele);
    for (let i = 0; i < data.length; i++) {
        setStylesToElement(data[i]);
    }
}
function setStylesToElement(data) {
    const { className, zIndex } = data;
    const elements = document.getElementsByClassName(className);
    Array.from(elements).forEach((el) => {
        const style = window.getComputedStyle(el);
        const position = style.position;
        if (position == "static") {
            el.style.position = "relative";
        }
        if (zIndex < 0) {
            el.style.opacity = 0;
        } else {
            el.style.opacity = 1;
        }
        el.style.zIndex = zIndex;
    });
}

function getElementsByClassAndAttributes(parentClassName) {
    const parentElement = document.querySelector(`.${parentClassName}`);
    if (!parentElement) {
        console.log('未找到指定的父元素');
        return [];
    }
    const children = parentElement.children;
    const results = [];
    for (let child of children) {
        const style = window.getComputedStyle(child);
        let currentClassName = child.className;
        const className = currentClassName.replace(/viewActive/g, '').trim();
        // const rect = child.getBoundingClientRect();
        // const left = rect.left + window.scrollX;
        // const top = rect.top + window.scrollY;
        const zIndex =
            style.zIndex === "auto" ? 0 : parseInt(style.zIndex, 10);
        results.push({
            className,
            zIndex
        });
    }
    return results;
}


function windowNodeView() {
    window.addEventListener("click", (e) => {
        const tagElement = getSpecificParentClassName(e.target);
        if (!tagElement) return
        const position = window.getComputedStyle(tagElement);
        const top = position.top ? parseFloat(position.top) : null;
        const left = position.left ? parseFloat(position.left) : null;
        const zIndex =
            position.zIndex === "auto" ? 0 : parseInt(position.zIndex, 10);
        let currentClassName = tagElement.className;
        const className = currentClassName.replace(/viewActive/g, '').trim();
        window.parent.postMessage(
            {
                type: "tagClicked",
                info: { className, zIndex },
            },
            "*"
        );
    });
    window.addEventListener("message", (event) => {
        if (event.origin !== process.env.VUE_APP_BASE_URL) {
            return;
        }
        if (event.data.message) {
            if (event.data.message.init) {
                const { className, zIndex } = event.data.message;
                const items = document.querySelectorAll("div");
                items.forEach((item) => {
                    if (item.className != className) {
                        item.classList.remove("viewActive");
                    }
                });
                const elements = document.getElementsByClassName(className);
                Array.from(elements).forEach((el) => {
                    const style = window.getComputedStyle(el);
                    const position = style.position;
                    if (position == "static") {
                        el.style.position = "relative";
                    }
                    if (zIndex < 0) {
                        el.style.opacity = 0;
                    } else {
                        el.style.opacity = 1;
                    }
                    el.style.zIndex = zIndex;
                    el.classList.add("viewActive");
                });
            } else {
                const containerResults = getElementsByClassAndAttributes('container-main');
                const pageContentResults = getElementsByClassAndAttributes('page-content');
                const combinedResults = [...containerResults, ...pageContentResults];
                window.parent.postMessage(
                    {
                        type: "alltag",
                        info: combinedResults,
                    },
                    "*"
                );
            }
        }

    })
}

function parentPostMessage(type, data = {}) {
    window.parent.postMessage(
        {
            type: type,
            info: data,
        },
        "*"
    );
}

/**
 * 隐藏手机号中间四位
 **/
function hidePhoneNumber(phoneNumber) {
	if (!phoneNumber) return
	const hiddenPhoneNumber = phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
	return hiddenPhoneNumber;
}




export default {
    detectDeviceType,
    setLocalStorage,
    getLocalStorage,
    setToken,
    getToken,
    setCookie,
    setAuthCookies,
    setWebCookie,
    getCookie,
    delCookie,
    clearAuthCookies,
    toChineseNumber,
    formatFileSize,
    getQueryParam,
    copyUrl,
    checkMediaType,
    tagChangeView,
    getSpecificParentClassName,
    setStylesToElement,
    windowNodeView,
    parentPostMessage,
    hidePhoneNumber

}
